import { useEffect, useState } from 'react';

import { checkAccountLockoutApi } from '../api/check-account-lockout.api';

type UseLockoutCheckParams = {
    lockoutError?: boolean;
    phoneNumber?: string;
};

type UseLockoutCheckReturn = {
    lockoutMinutes: number | undefined;
    showLockoutError: boolean;
};

/**
 * Hook to check if an account is locked out on page load
 * @param lockoutError - Flag indicating if there was a lockout error
 * @param phoneNumber - The phone number to check (already formatted, e.g., +14256003494)
 * @returns Object containing lockout minutes and flag to show error
 */
export const useLockoutCheck = ({
    lockoutError,
    phoneNumber,
}: UseLockoutCheckParams): UseLockoutCheckReturn => {
    const [lockoutMinutes, setLockoutMinutes] = useState<number | undefined>();
    const [showLockoutError, setShowLockoutError] = useState<boolean>(false);

    useEffect(() => {
        const checkLockout = async () => {
            if (lockoutError && phoneNumber) {
                const lockoutStatus = await checkAccountLockoutApi(phoneNumber);

                if (
                    lockoutStatus.isLocked &&
                    lockoutStatus.minutesUntilUnlock
                ) {
                    setLockoutMinutes(lockoutStatus.minutesUntilUnlock);
                    setShowLockoutError(true);
                }
            }
        };

        checkLockout();
    }, [lockoutError, phoneNumber]);

    return { lockoutMinutes, showLockoutError };
};
